import React, { useState, createElement } from 'react';
import Button from './Button';
interface ConfettiButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  disabled?: boolean;
  className?: string;
}
const ConfettiButton: React.FC<ConfettiButtonProps> = ({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  className = ''
}) => {
  const [showConfetti, setShowConfetti] = useState(false);
  const handleClick = () => {
    setShowConfetti(true);
    // Create confetti effect
    const confettiCount = 100;
    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.top = '0';
    container.style.left = '0';
    container.style.width = '100vw';
    container.style.height = '100vh';
    container.style.pointerEvents = 'none';
    container.style.zIndex = '9999';
    document.body.appendChild(container);
    // Create confetti pieces
    for (let i = 0; i < confettiCount; i++) {
      const confetti = document.createElement('div');
      const colors = ['#E84118', '#FFC312', '#009432', '#0652DD'];
      confetti.style.position = 'absolute';
      confetti.style.width = `${Math.random() * 10 + 5}px`;
      confetti.style.height = `${Math.random() * 5 + 5}px`;
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.borderRadius = '50%';
      confetti.style.opacity = '0.8';
      // Random starting position
      const startX = window.innerWidth / 2;
      const startY = window.innerHeight / 2;
      confetti.style.left = `${startX}px`;
      confetti.style.top = `${startY}px`;
      container.appendChild(confetti);
      // Animate each piece
      const angle = Math.random() * Math.PI * 2;
      const velocity = Math.random() * 5 + 5;
      const vx = Math.cos(angle) * velocity;
      const vy = Math.sin(angle) * velocity;
      let x = startX;
      let y = startY;
      let opacity = 1;
      const animate = () => {
        x += vx;
        y += vy - 0.5; // Gravity effect
        opacity -= 0.02;
        confetti.style.left = `${x}px`;
        confetti.style.top = `${y}px`;
        confetti.style.opacity = `${opacity}`;
        if (opacity > 0) {
          requestAnimationFrame(animate);
        } else {
          container.removeChild(confetti);
          if (container.childElementCount === 0) {
            document.body.removeChild(container);
          }
        }
      };
      requestAnimationFrame(animate);
    }
    if (onClick) onClick();
  };
  return <Button onClick={handleClick} variant={variant} size={size} fullWidth={fullWidth} disabled={disabled || showConfetti} className={className} data-id="element-178">
      {children}
    </Button>;
};
export default ConfettiButton;